<template>
    <div class="custome_div addtext_rotation_wrap">
        <div class="addtext_font rotation add_font_mobile_w">
            <div class="form-group">
                <div class="range">
                    <!-- eslint-disable -->
                    <input
                        v-model="value"
                        v-on:change="setValue"
                        id="rotationValue"
                        type="range"
                        value="0"
                        min="-360"
                        max="360"
                        class="input_type_rang_custom"
                    />
                    <!-- eslint-enable -->
                </div>
                <label>Rotation</label><span class="highlight"></span>
            </div>
        </div>

        <div
            :class="
                (mTop === 0 ? 'setwidth_top_margin ' : ' ') +
                'addtext_color font-size_add rot_value'
            "
        >
            <div class="form-group">
                <!-- eslint-disable -->
                <input
                    v-on:change="setValue"
                    type="number"
                    v-model="value"
                    id="rotationValueInput"
                    required="required"
                    placeholder="0"
                    min="-360"
                    max="360"
                    class="range_slider_input span2 form-control bg-whit"
                />
                <!-- eslint-enable -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Rotation",
    /* eslint-enable */
    props: ["value", "mTop"],
    data: () => {
        return {};
    },
    watch: {
        value: function (newData, oldData) {
            /* eslint-disable */
            if (newData != oldData) this.value = newData;
            /* eslint-enable */
        }
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", Number(e.target.value));
        }
    }
};
</script>

<style></style>
